import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select/lib/Async';
import fetch from 'unfetch';

import { parseGeoCoderResult, getSuggestUrl, getGeoCodingUrl } from './utils';

import DropdownIndicator from '~/core/scripts/components/CustomReactSelect/DropdownIndicator';
import ClearIndicator from '~/core/scripts/components/CustomReactSelect/ClearIndicator';
import SearchPresets from '~/core/scripts/components/SearchPresets';

import '../CustomReactSelect/CustomReactSelect.styl';
import './Geocoder.styl';

const isAreaGeocoder = baseconfig.app.geocoderOptions.resultType === 'areas';

class Geocoder extends PureComponent {
  static propTypes = {
    hereAppId: PropTypes.string,
    hereAppCode: PropTypes.string,
    center: PropTypes.arrayOf(PropTypes.number),
    country: PropTypes.string,
    radius: PropTypes.number,
    onSelect: PropTypes.func,
    notFoundMessage: PropTypes.string,
    placeholder: PropTypes.string,
    title: PropTypes.string,
    setGeocodeOutOfRange: PropTypes.func
  };

  static defaultProps = {
    hereAppId: 'WOhEXnd20kbhT8Lxx4n4',
    hereAppCode: 'uFkDYK0WKXBPZgG8mRb9Rg',
    center: [52.50697, 13.2843072],
    country: 'DEU',
    radius: 25000,
    onSelect: () => {},
    notFoundMessage: isAreaGeocoder
      ? 'Ort konnte nicht gefunden werden.'
      : 'Adresse konnte nicht gefunden werden.',
    placeholder: isAreaGeocoder
      ? 'Geben Sie einen Ort ein...'
      : 'Geben Sie eine Adresse ein...',
    title: null,
    setGeocodeOutOfRange: () => {}
  };

  loadOptions(inputValue) {
    if (inputValue.length < 3) {
      return null;
    }
    const requestUrl = getSuggestUrl({
      query: inputValue,
      app_id: this.props.hereAppId,
      app_code: this.props.hereAppCode,
      country: this.props.country,
      center: this.props.center,
      radius: this.props.radius
    });

    return new Promise(async (resolve, reject) => {
      const response = await fetch(requestUrl);
      const options = await response.json();
      resolve(parseGeoCoderResult(options));
    });
  }

  handleSelect = async option => {
    if (!option) {
      this.props.setGeocodeOutOfRange(false);
      return false;
    }

    const requestUrl = getGeoCodingUrl({
      locationId: option.locationId,
      app_id: this.props.hereAppId,
      app_code: this.props.hereAppCode
    });

    const response = await fetch(requestUrl);
    const result = await response.json();

    this.props.onSelect(result);
  };

  onPresetClick(preset) {
    this.selectContainer.select.select.setValue({
      __label: preset.name,
      locationId: preset.locationId
    });
  }

  render() {
    const {
      title,
      presets = [],
      presetsTitle = '',
      geocodeOutOfRange
    } = this.props;

    return (
      <div className="geocoder">
        {title && <div className="geocoder__title">{title}</div>}
        <ReactSelect
          ref={ref => {
            this.selectContainer = ref;
            window.select = this.selectContainer;
          }}
          loadOptions={inputValue => this.loadOptions(inputValue)}
          getOptionLabel={option => option.__label}
          cacheOptions
          isClearable
          openMenuOnClick={false}
          openMenuOnFocus={false}
          onBlurResetsInput={false}
          onChange={option => this.handleSelect(option)}
          placeholder={this.props.placeholder}
          className="react-select__wrap"
          classNamePrefix="react-select"
          noOptionsMessage={input => {
            if (!input.inputValue || input.inputValue.length < 2) {
              return null;
            }

            return this.props.notFoundMessage;
          }}
          components={{
            DropdownIndicator,
            ClearIndicator,
            IndicatorSeparator: () => null
          }}
          theme={theme => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: '#4C80BC', // blue50
              primary75: '#83B0E5', // blue65
              primary50: '#A4C8F1', // blue75
              primary25: '#C9E2FF' // blue85
            }
          })}
          styles={{
            menu: (provided, state) => ({
              ...provided,
              zIndex: 99999
            })
          }}
        />
        {geocodeOutOfRange && (
          <div className="geocoder__error">
            Die gesuchte Adresse liegt außerhalb von Hamburg.
          </div>
        )}
        <SearchPresets
          presets={presets}
          onClick={p => this.onPresetClick(p)}
          title={presetsTitle}
        />
      </div>
    );
  }
}

export default Geocoder;
